var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SortOrderEnum } from '@workalizer/shared';
export function buildMetricColumnIndexByField(fields, labelColumnIndex) {
    if (labelColumnIndex === void 0) { labelColumnIndex = 0; }
    var offset = labelColumnIndex + 1;
    return Object.fromEntries(fields.map(function (field, index) { return [field, index + offset]; }));
}
export function getSortDirectionMultiplier(direction) {
    return direction === SortOrderEnum.ASC ? 1 : -1;
}
export function sortWidgetTableRows(items, sortBy, getSortValue, options) {
    if ((options === null || options === void 0 ? void 0 : options.skipWhenField) === sortBy.field) {
        return __spreadArray([], items, true);
    }
    var multiplier = getSortDirectionMultiplier(sortBy.direction);
    return __spreadArray([], items, true).sort(function (a, b) {
        var aValue = getSortValue(a, sortBy.field);
        var bValue = getSortValue(b, sortBy.field);
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return (multiplier *
                aValue.localeCompare(bValue, undefined, { sensitivity: 'base' }));
        }
        return multiplier * (Number(aValue) - Number(bValue));
    });
}
export function buildWidgetTableSortingOption(sortBy, columnIndexByField, options) {
    var hide = (options === null || options === void 0 ? void 0 : options.hideWhenField) === sortBy.field;
    return {
        show: !hide,
        elementIndex: columnIndexByField[sortBy.field],
        orderByField: sortBy.field,
        direction: sortBy.direction,
        orderByDirection: sortBy.direction
    };
}
